import type Lenis from 'lenis'

import { USE_TARGETS } from '@/constants/site'

export type UseTarget = typeof USE_TARGETS[number]

export const USE_TARGET_EVENT = 'softly:use-target'

// Height of the fixed header, so sections never land underneath it.
export const HEADER_OFFSET = 84

export const isUseTarget = (value: string): value is UseTarget =>
    (USE_TARGETS as readonly string[]).includes(value)

// Scrolls to an element on the current page, through Lenis when it is running.
export const scrollToId = (id: string, lenis?: Lenis, onComplete?: () => void): void => {
    const element = document.getElementById(id)

    if (!element) return

    if (lenis) {
        lenis.scrollTo(element, { offset: -HEADER_OFFSET, duration: 1.6, onComplete: () => onComplete?.() })
        return
    }

    const top = element.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET

    window.scrollTo({ top, behavior: 'smooth' })
    onComplete?.()
}

// Moves to an in-page hash. Use targets switch the carousel first, the signup focuses its field.
export const goToHash = (hash: string, lenis?: Lenis): void => {
    const id = hash.replace(/^\/?#/, '')

    if (isUseTarget(id)) {
        window.dispatchEvent(new CustomEvent<UseTarget>(USE_TARGET_EVENT, { detail: id }))
        scrollToId('uses', lenis)
        return
    }

    if (id === 'join') {
        scrollToId('join', lenis, () => document.getElementById('join-email')?.focus({ preventScroll: true }))
        return
    }

    scrollToId(id, lenis)
}
